var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:_vm.fill ? 'fill' : '',attrs:{"outlined":"","max-width":"100","min-height":"80"}},[_c('v-container',{staticClass:"text-center"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }